import React from "react";
import styled from "styled-components";
import Header from "../commons/Header";
import Footer from "../commons/Footer";
import SectionErrorBoundary from "../homes/SectionErrorBoundary";
import ProvideLandingSearch from "../providers/ProvideLandingSearch";

import WebinarHero from "./sections/WebinarHero";
import WebinarRecording from "./sections/WebinarRecording";
import WebinarDetails from "./sections/WebinarDetails";
import WebinarRelated from "./sections/WebinarRelated";

const Page = styled.div`
  background: #ffffff;
  min-height: 100vh;
  color: #1f2937;
  font-family: "Montserrat", sans-serif;

  &[data-theme="dark"] {
    background: #0f172a;
    color: #f3f4f6;
  }
`;

// WebinarsController passes `theme` ('dark'|'light') based on the
// `dark_mode_v1` FeatureToggle, and `authRebrand` based on `auth_rebrand_v1`
// so the React client builds the right login-redirect URL without reading
// toggle state from JS. Matches HomesApp's data-theme pattern exactly.
export default function WebinarShowApp({ theme = "light", authRebrand = false, webinar }) {
  const resolved = theme === "dark" ? "dark" : "light";

  React.useEffect(() => {
    document.documentElement.setAttribute("data-theme", resolved);
    return () => document.documentElement.removeAttribute("data-theme");
  }, [resolved]);

  // Local copy of the webinar prop so optimistic register/cancel mutations
  // can flip UI state without a full Inertia reload. On success the
  // registration hook issues router.reload({ only: ['webinar'] }) to pull
  // the authoritative server-computed payload (including recomputed `cta`).
  const [webinarState, setWebinarState] = React.useState(webinar);

  React.useEffect(() => {
    setWebinarState(webinar);
  }, [webinar]);

  return (
    <ProvideLandingSearch>
      <Page data-theme={resolved}>
        <Header />
        <SectionErrorBoundary name="WebinarHero">
          <WebinarHero
            webinar={webinarState}
            setWebinar={setWebinarState}
            authRebrand={authRebrand}
          />
        </SectionErrorBoundary>
        <SectionErrorBoundary name="WebinarRecording">
          <WebinarRecording webinar={webinarState} />
        </SectionErrorBoundary>
        <SectionErrorBoundary name="WebinarDetails">
          <WebinarDetails webinar={webinarState} />
        </SectionErrorBoundary>
        <SectionErrorBoundary name="WebinarRelated">
          <WebinarRelated slug={webinarState.slug} />
        </SectionErrorBoundary>
        <Footer />
      </Page>
    </ProvideLandingSearch>
  );
}
